import React, { Component } from "react";

class Score extends Component {

    formatScore() {
        var s = this.props.score + "";
        if (s.length < 9) {
            const dif = 9 - s.length;
            var c = "";
            for (var i = 0; i < dif; i++) {
                c = c + "0"
            }
            return c;
        }
        return '';
        
	} 

	render() {
        const { score } = this.props;
		return (
			<div className="score">
                <span>{this.formatScore()}</span>{`${score === 0 ? '' : score }`}
            </div>
		);
	}
}

export default Score;


// WEBPACK FOOTER //
// ./src/components/hud/Score.js